import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-border-all",
  templateUrl: "./med-icon-border-all.component.html",
})
export class MedIconBorderAllComponent extends SvgMixinComponent {}
